import {RailsApi} from '@/api/rails.api.js'
import {useRailsUrls} from '@/composables/use-rails-urls.js'

/**
 * Auth API class
 */
export class AuthApi extends RailsApi {

  //Props
  basePath = '/'

  /**
   * Authenticate with MS Teams SSO token
   */
  authenticateWithTeamsSSOToken(token, userData = {}) {
    return this
      .post('/microsoft/authentication_tokens', {
        token,
        ...userData,
      })
  }

  /**
   * Get CSRF token from API endpoint
   */
  getCsrfToken() {
    return this
      .get('/csrf_token')
      .then(data => data.csrfToken)
  }

  /**
   * Exchange an Auth0 ID token for an HttpOnly cookie on the Rails backend.
   * Uses railsAppRootUrl directly since this route lives outside /api/v1.
   * Skips bearer and CSRF headers from being appended to the request config.
   */
  syncAuthCookie(token) {
    const {railsAppRootUrl} = useRailsUrls()
    return this.post(`${railsAppRootUrl.value}/auth/set_cookie`, {token}, {
      skipBearerToken: true,
      skipCsrfToken: true,
    })
  }
}

//Export singleton instance
export const authApi = new AuthApi()
